import moment from 'moment';
import { Component } from 'react';
import Skeleton from 'react-loading-skeleton';
import { Link } from 'react-router-dom';
import { promobannerStore } from '../../store/promobannerStore';
import { TPromobanner } from '../../types/promobanners';
import { SCREENS } from 'src/constants/screens';
import { TBooleanInNumber } from 'src/types/main';
import { formatDate } from 'src/utils/helpers';
import Switcher from 'src/view/components/Controls/Switcher/Switcer';
import Text, { TEXT } from 'src/view/components/Text/Text';
import './style.scss';

interface IProps {
  promobanner?: TPromobanner;
}

export default class PromobannersListItem extends Component<IProps, {}> {
  changeStatus = (status: TBooleanInNumber) => {
    if (!this.props.promobanner || !this.props.promobanner.id) return;
    promobannerStore.changeStatus(this.props.promobanner.id, status);
  };

  get endDate(): string | undefined {
    if (!this.props.promobanner) return undefined;
    return moment(this.props.promobanner.end_date).isAfter(moment('2120-01-01')) ? '' : formatDate(this.props.promobanner.end_date);
  }

  render() {
    return (
      <li className="promobanner-item d-flex flex-row full-width align-items-center">
        <div className="d-flex flex-row align-items-center pr-4 w-40">
          {this.props.promobanner ? <Text type={TEXT.LIST_ROW} text={this.props.promobanner.name} /> : <Skeleton width={90} height={16} />}
        </div>
        <div className="d-flex flex-row align-items-center pr-4 w-14">
          {this.props.promobanner ? (
            <Text type={TEXT.LIST_ROW} text={formatDate(this.props.promobanner?.start_date)} noTranslate />
          ) : (
            <Skeleton width={90} height={16} />
          )}
        </div>
        <div className="d-flex flex-row align-items-center pr-4 w-16">
          {this.props.promobanner ? <Text type={TEXT.LIST_ROW} text={this.endDate} noTranslate /> : <Skeleton width={90} height={16} />}
        </div>
        <div className="d-flex flex-row align-items-center pr-4 w-23">
          {this.props.promobanner ? <Text type={TEXT.LIST_ROW} text={this.props.promobanner.category?.name} /> : <Skeleton width={110} height={16} />}
        </div>
        <div className="d-flex flex-row align-items-center promobanner-item__switcher w-7">
          {this.props.promobanner ? (
            <Switcher status={this.props.promobanner.status} onChange={this.changeStatus} />
          ) : (
            <Skeleton width={50} height={30} style={{ borderRadius: 30 }} />
          )}
        </div>
        <Link to={SCREENS.PROMOBANNER_EDIT(this.props.promobanner?.id || 0)} className="promobanner-item__edit-link"></Link>
      </li>
    );
  }
}
